var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',{staticClass:"d-flex justify-content-center",attrs:{"secondary":""}},[_c('router-link',{staticClass:"text-light",attrs:{"to":_vm.route}},[_c('i',{staticClass:"uil-exchange"}),_vm._v(" "+_vm._s(`${_vm.$t('helpers.goTo')} ${_vm.destiny}`)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }